<div class="icon">
  <i class="material-icons cursor-default">
    {{aircraftCode | getAircraftIcon}}
  </i>
</div>
